<div class="container-fluid">
    <div class="row">
        <app-section-title title="TITLES.CHECK-MEASUREMENTS-PRODUCTS">
        </app-section-title>
    </div>
    <p>check-measurements-products works!</p>
</div>